.root {
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.1875rem;

  &[data-variant='blue'] {
    color: var(--mantine-color-tertiary-9);
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }

    &:disabled {
      color: var(--mantine-color-primary-9);
    }
  }

  &[data-variant='gray'] {
    color: var(--mantine-color-primary-9);

    &:hover {
      color: var(--mantine-color-primary-7);
      text-decoration: none;
    }
  }

  &[data-variant='black'] {
    color: var(--mantine-color-otherBlack-0);
    text-decoration: none;

    &:hover {
      color: var(--mantine-color-tertiary-9);
    }

    &:active {
      color: var(--mantine-color-otherBlack-0);
    }

    &:disabled {
      color: var(--mantine-color-primary-9);
    }
  }

  &[data-variant='unstyled'] {
    color: var(--mantine-color-otherBlack-0);
    text-decoration: none;
  }
}
